import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e500f69e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-claim__checkout-backdrop" }, null, -1))
const _hoisted_2 = { class: "m-claim__checkout-container m-claim" }

import { BigNumber } from '@ethersproject/bignumber';
import { formatEther } from '@ethersproject/units';
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { onBeforeMount, onMounted, onUnmounted, ref } from 'vue';
import BuyWithEthPage from '@/components/checkout/BuyWithEthPage.vue';
import CheckoutHeader from '@/components/checkout/CheckoutHeader.vue';
import * as telemetry from '@/lib/telemetry';
import { useClaimStore } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollectButton',
  setup(__props) {

_useCssVars(_ctx => ({
  "8cc492c6": (_unref(store).clientColors.themePrimary)
}))

const store = useClaimStore();

const isModalOpen = ref(false);
const checkoutState = ref<'payment-method' | 'buy-with-eth' | 'buy-with-card' | 'success'>(
  'buy-with-eth'
);
const purchaseSucceded = ref(false);

const onSuccess = () => {
  purchaseSucceded.value = true;
};

const floorPrice = ref(BigNumber.from(0));
const floorPriceInUsd = ref(0);

// Need this to make sure the modal height is correct on Safari
const vh95 = ref('0px');

const setMaxHeight = () => {
  vh95.value = window.innerHeight * 0.95 + 'px';
};

onBeforeMount(() => {
  setMaxHeight();
  window.addEventListener('resize', setMaxHeight);
});

onMounted(() => {
  floorPrice.value = store.getFloorPrice();
  floorPriceInUsd.value = +formatEther(floorPrice.value) * store.ethToUsdRate;
});

onUnmounted(() => {
  window.removeEventListener('resize', setMaxHeight);
});

const goToBuyWithCard = () => {
  telemetry.collectPaymentPreview('card');
  checkoutState.value = 'buy-with-card';
};

const open = () => {
  store.initializeFiatPrices();

  store.analytics.capture({
    event: telemetry.TELEMETRY_MAPPING.mintFlow.BUY_ON_SECONDARY_BUTTON_CLICK,
  });

  checkoutState.value = 'buy-with-eth';
  isModalOpen.value = true;
  telemetry.collectPreview('eth');
};

const close = async () => {
  isModalOpen.value = false;
  purchaseSucceded.value = false;
  await store.setFloorPrices();
  floorPrice.value = store.getFloorPrice();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "campaign-action" }, _ctx.$attrs), [
    _createVNode(_unref(TransitionRoot), { show: isModalOpen.value }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          class: "checkout",
          onClose: close
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "m-claim__checkout-backdrop__enter-animation",
              "enter-from": "m-claim__checkout-backdrop__enter-from-animation",
              "enter-to": "m-claim__checkout-backdrop__enter-to-animation",
              leave: "m-claim__checkout-backdrop__leave-animation",
              "leave-from": "m-claim__checkout-backdrop__leave-from-animation",
              "leave-to": "m-claim__checkout-backdrop__leave-to-animation"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "m-claim__checkout__enter-animation",
              "enter-from": "m-claim__checkout__enter-from-animation",
              "enter-to": "m-claim__checkout__enter-to-animation",
              leave: "m-claim__checkout__leave-animation",
              "leave-from": "m-claim__checkout__leave-from-animation",
              "leave-to": "m-claim__checkout__leave-to-animation"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(DialogPanel), {
                    class: _normalizeClass([
                'm-claim__checkout-modal',
                {
                  'm-claim__checkout-modal--card': checkoutState.value === 'buy-with-card',
                  success: purchaseSucceded.value,
                },
              ]),
                    style: _normalizeStyle({ 'max-height': vh95.value })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CheckoutHeader, {
                        "on-close": close,
                        success: checkoutState.value === 'success'
                      }, null, 8, ["success"]),
                      _createVNode(BuyWithEthPage, {
                        "go-to-pay-with-card": goToBuyWithCard,
                        "on-success": onSuccess
                      })
                    ]),
                    _: 1
                  }, 8, ["class", "style"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    (_unref(store).floorPrices.length > 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "campaign-buy-button",
          onClick: open
        }, [
          _createElementVNode("span", null, _toDisplayString(`Buy from secondary • ${_unref(formatEther)(floorPrice.value)} ETH`), 1)
        ]))
      : _createCommentVNode("", true)
  ], 16))
}
}

})